<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <el-dialog :visible.sync="dialogVisible"
    :width="width"
    :title="title"

    :before-close="handleClose"
  >
    <el-form class="mt16" :model="formData" :rules="rules" ref="followForm">
      <el-form-item label="跟进记录："  prop="describe" label-width="90px">
        <el-input
          type="textarea"
          :rows="5"
          maxlength="500"
          show-word-limit
          placeholder="请输入跟进记录"
          v-model="formData.describe" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { addFollow } from '@/api/domain/orders'

export default {
  components: {
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    receivableId: {
      type: Number,
    },
    title: {
      type: String,
      default: '跟进',
    },
    width: {
      type: String,
      default: '590px',
    },
  },
  data() {
    return {
      formData: {
        describe: '',
      },
      rules: {
        describe: [
          { require: true, message: '请输入跟进记录', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$refs.followForm.validate(async (valid) => {
        if (valid) {
          const { code } = await addFollow({
            ...this.formData,
            // receivableId: this.receivableId
            overdueId: this.receivableId,
          })
          if (code === 1) {
            this.$message.success('添加成功')
            this.$emit('refresh')
            this.handleClose()
          }
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">

</style>
